import { PaymentIssuer, PaymentMethodEnum } from '@pe/checkout/types';

export type PaymentTranslationType = Partial<Record<PaymentMethodEnum, string>>;
export type PaymentIssuerTranslationType = Partial<
  Record<PaymentMethodEnum,
  Partial<Record<PaymentIssuer, string>>>
>;

export type ValuesTranslationsType = Record<string, string>;

export const PAYMENT_TRANSLATIONS: PaymentTranslationType = {
  [PaymentMethodEnum.PSA_B2B_BNPL]: $localize `:@@payment_methods.psa_b2b_bnpl:`,
  [PaymentMethodEnum.ALLIANZ]: $localize `:@@payment_methods.allianz_trade_b2b_bnpl:`,
  [PaymentMethodEnum.BFS_B2B_BNPL]: $localize `:@@payment_methods.bfs_b2b_bnpl:`,
  [PaymentMethodEnum.HSBC]: $localize `:@@payment_methods.hsbc:`,
  [PaymentMethodEnum.CASH]: $localize `:@@payment_methods.cash:`,
  [PaymentMethodEnum.INSTANT_PAYMENT]: $localize `:@@payment_methods.instant_payment:`,
  [PaymentMethodEnum.IVY]: $localize `:@@payment_methods.ivy:`,
  [PaymentMethodEnum.PAYPAL]: $localize `:@@payment_methods.paypal:`,
  [PaymentMethodEnum.PRZELEWY]: $localize `:@@payment_methods.przelewy:Przelewy24`,
  [PaymentMethodEnum.SANTANDER_FACTORING_DE]: $localize `:@@payment_methods.santander_factoring_de:`,
  [PaymentMethodEnum.SANTANDER_INSTALLMENT]: $localize `:@@payment_methods.santander_installment:`,
  [PaymentMethodEnum.SANTANDER_INSTALLMENT_AT]: $localize `:@@payment_methods.santander_installment_at:`,
  [PaymentMethodEnum.SANTANDER_INSTALLMENT_BE]: $localize `:@@payment_methods.santander_installment_be:`,
  [PaymentMethodEnum.SANTANDER_INSTALLMENT_DK]: $localize `:@@payment_methods.santander_installment_dk:`,
  [PaymentMethodEnum.SANTANDER_INSTALLMENT_FI]: $localize `:@@payment_methods.santander_installment_fi:`,
  [PaymentMethodEnum.SANTANDER_POS_INSTALLMENT_FI]: $localize `:@@payment_methods.santander_pos_installment_fi:`,
  [PaymentMethodEnum.SANTANDER_INSTALLMENT_NL]: $localize `:@@payment_methods.santander_installment_nl:`,
  [PaymentMethodEnum.SANTANDER_INSTALLMENT_NO]: $localize `:@@payment_methods.santander_installment_no:`,
  [PaymentMethodEnum.SANTANDER_INSTALLMENT_SE]: $localize `:@@payment_methods.santander_installment_se:`,
  [PaymentMethodEnum.SANTANDER_INSTALLMENT_UK]: $localize `:@@payment_methods.santander_installment_uk:`,
  [PaymentMethodEnum.SANTANDER_INVOICE_DE]: $localize `:@@payment_methods.santander_invoice_de:`,
  [PaymentMethodEnum.SANTANDER_INVOICE_NO]: $localize `:@@payment_methods.santander_invoice_no:`,
  [PaymentMethodEnum.SANTANDER_POS_FACTORING_DE]: $localize `:@@payment_methods.santander_pos_factoring_de:`,
  [PaymentMethodEnum.SANTANDER_POS_INSTALLMENT]: $localize `:@@payment_methods.santander_pos_installment:`,
  [PaymentMethodEnum.SANTANDER_POS_INSTALLMENT_AT]: $localize `:@@payment_methods.santander_pos_installment_at:`,
  [PaymentMethodEnum.SANTANDER_POS_INSTALLMENT_DK]: $localize `:@@payment_methods.santander_pos_installment_dk:`,
  [PaymentMethodEnum.SANTANDER_POS_INSTALLMENT_NO]: $localize `:@@payment_methods.santander_pos_installment_no:`,
  [PaymentMethodEnum.SANTANDER_POS_INSTALLMENT_SE]: $localize `:@@payment_methods.santander_pos_installment_se:`,
  [PaymentMethodEnum.SANTANDER_POS_INSTALLMENT_UK]: $localize `:@@payment_methods.santander_pos_installment_uk:`,
  [PaymentMethodEnum.SANTANDER_POS_INVOICE_DE]: $localize `:@@payment_methods.santander_pos_invoice_de:`,
  [PaymentMethodEnum.SANTANDER_POS_INVOICE_NO]: $localize `:@@payment_methods.santander_pos_invoice_no:`,
  [PaymentMethodEnum.SOFORT]: $localize `:@@payment_methods.sofort:`,
  [PaymentMethodEnum.SWEDBANK_CREDITCARD]: $localize `:@@payment_methods.swedbank_creditcard:`,
  [PaymentMethodEnum.SWEDBANK_INVOICE]: $localize `:@@payment_methods.swedbank_invoice:`,
  [PaymentMethodEnum.SWEDBANK_VIPPS]: $localize `:@@payment_methods.swedbank_vipps:`,
  [PaymentMethodEnum.SWEDBANK_MOBILE_PAY]: $localize `:@@payment_methods.swedbank_mobile_pay:`,
  [PaymentMethodEnum.SWEDBANK_SWISH]: $localize `:@@payment_methods.swedbank_swish:`,
  [PaymentMethodEnum.TRUSTLY]: $localize `:@@payment_methods.trustly:Trustly`,
  [PaymentMethodEnum.ZINIA_BNPL]: $localize `:@@payment_methods.zinia_bnpl:`,
  [PaymentMethodEnum.ZINIA_BNPL_DE]: $localize `:@@payment_methods.zinia_bnpl_de:`,
  [PaymentMethodEnum.ZINIA_INSTALLMENT]: $localize `:@@payment_methods.zinia_installment:`,
  [PaymentMethodEnum.ZINIA_INSTALLMENT_DE]: $localize `:@@payment_methods.zinia_installment_de:`,
  [PaymentMethodEnum.ZINIA_POS]: $localize `:@@payment_methods.zinia_pos:`,
  [PaymentMethodEnum.ZINIA_POS_DE]: $localize `:@@payment_methods.zinia_pos_de:`,
  [PaymentMethodEnum.ZINIA_SLICE_THREE]: $localize `:@@payment_methods.zinia_slice_three:`,
  [PaymentMethodEnum.ZINIA_SLICE_THREE_DE]: $localize `:@@payment_methods.zinia_slice_three_de:`,
  [PaymentMethodEnum.ZINIA_POS_INSTALLMENT]: $localize `:@@payment_methods.zinia_installment:`,
  [PaymentMethodEnum.ZINIA_POS_INSTALLMENT_DE]: $localize `:@@payment_methods.zinia_installment_de:`,
  [PaymentMethodEnum.ZINIA_POS_SLICE_THREE]: $localize `:@@payment_methods.zinia_slice_three:`,
  [PaymentMethodEnum.ZINIA_POS_SLICE_THREE_DE]: $localize `:@@payment_methods.zinia_slice_three_de:`,
  [PaymentMethodEnum.ZINIA_POS_LENDING_DE]: $localize `:@@payment_methods.zinia_pos_lending_de:Zinia loan POS DE`,
  [PaymentMethodEnum.ZINIA_LENDING_DE]: $localize `:@@payment_methods.zinia_lending_de:Zinia lending`,
  [PaymentMethodEnum.SANTANDER_INSTANT]: $localize `:@@payment_methods.santander_instant:Santander Instant`,
  [PaymentMethodEnum.SANTANDER_INSTANT_AT]: $localize `:@@payment_methods.santander_instant:Santander Instant`,
  [PaymentMethodEnum.PAY_BY_BANK]: $localize `:@@payment_methods.pay_by_bank:Pay by bank`,
  [PaymentMethodEnum.ECOCHEQUE]: $localize `:@@payment_issuer.ecocheque:Ecocheque`,

  [PaymentMethodEnum.SANTANDER_INVOICE_AT]: $localize `:@@payment_methods.santander_invoice_at:Santander AT BNPL`,
  [PaymentMethodEnum.BNPL]: $localize `:@@payment_methods.verifone_bnpl:Verifone BNPL`,
  [PaymentMethodEnum.BANCONTACT]: $localize `:@@payment_methods.bancontact:Bancontact`,
  [PaymentMethodEnum.TWINT]: $localize `:@@payment_methods.twint:Twint`,
  [PaymentMethodEnum.BLIK]: $localize `:@@payment_methods.blik:Blik`,
  [PaymentMethodEnum.EPS]: $localize `:@@payment_methods.eps:EPS`,
  [PaymentMethodEnum.BIZUM]: $localize `:@@payment_methods.bizum:Bizum`,
  [PaymentMethodEnum.RESURS_INSTALLMENT]: $localize `:@@payment_methods.resurs_installment:Resurs installments`,
  [PaymentMethodEnum.RESURS_POS_INSTALLMENT]: $localize `:@@payment_methods.resurs_pos_installment:Resurs installments`,
  [PaymentMethodEnum.RESURS_INVOICE]: $localize `:@@payment_methods.resurs_invoice:Resurs invoice`,
  [PaymentMethodEnum.RESURS_POS_INVOICE]: $localize `:@@payment_methods.resurs_pos_invoice:Resurs invoice`,
  [PaymentMethodEnum.PAYBACK]: $localize `:@@payment_methods.payback:PAYBACK PAY`,
  [PaymentMethodEnum.POWERPAY_REVOLVING]: $localize `:@@payment_methods.powerpay_revolving:`,
  [PaymentMethodEnum.POWERPAY_INSTALLMENT]: $localize `:@@payment_methods.powerpay_installment:`,
};

export const PAYMENT_ISSUER_TRANSLATIONS: PaymentIssuerTranslationType = {
  [PaymentMethodEnum.ECOCHEQUE]: {
    [PaymentIssuer.EDENRED]: $localize `:@@payment_methods.edenred:Edenred`,
    [PaymentIssuer.SODEXO]: $localize `:@@payment_methods.sodexo:Sodexo`,
    [PaymentIssuer.MONIZZE]: $localize `:@@payment_methods.monizze:Monizze`,
  },
  [PaymentMethodEnum.GOOGLE_PAY]: {
    [PaymentIssuer.STRIPE]: $localize `:@@payment_methods.google_pay_stripe:`,
    [PaymentIssuer.VERIFONE]: $localize `:@@payment_methods.google_pay_verifone:`,
  },
  [PaymentMethodEnum.APPLE_PAY]: {
    [PaymentIssuer.STRIPE]: $localize `:@@payment_methods.apple_pay_stripe:`,
    [PaymentIssuer.VERIFONE]: $localize `:@@payment_methods.apple_pay_verifone:`,
  },
  [PaymentMethodEnum.CREDIT_CARD]: {
    [PaymentIssuer.STRIPE]: $localize `:@@payment_methods.credit_card_stripe:`,
    [PaymentIssuer.VERIFONE]: $localize `:@@payment_methods.credit_card_verifone:`,
    [PaymentIssuer.GLOBAL_PAYMENTS]: $localize `:@@payment_methods.credit_card_global_payments:`,
  },
  [PaymentMethodEnum.DIRECT_DEBIT]: {
    [PaymentIssuer.VERIFONE]: $localize `:@@payment_methods.verifone_direct_debit:`,
    [PaymentIssuer.STRIPE]: $localize `:@@payment_methods.stripe_directdebit:`,
  },
  [PaymentMethodEnum.BNPL]: {
    [PaymentIssuer.VERIFONE]: $localize `:@@payment_methods.verifone_bnpl:`,
  },
  [PaymentMethodEnum.IDEAL]: {
    [PaymentIssuer.STRIPE]: $localize `:@@payment_methods.stripe_ideal:`,
    [PaymentIssuer.PPRO]: $localize `:@@payment_methods.ppro_ideal:`,
  },
  [PaymentMethodEnum.TRUSTLY]: {
    [PaymentIssuer.SWEDBANK]: $localize `:@@payment_methods.swedbank_trustly:`,
    [PaymentIssuer.PPRO]: $localize `:@@payment_methods.ppro_trustly:`,
  },
  [PaymentMethodEnum.WERO]: {
    [PaymentIssuer.PPRO]: $localize `:@@payment_methods.wero:WERO:`,
  },
};

export const PAYMENT_CUSTOM_TITLE_TRANSLATIONS: Record<string, string> = {
  'integrations.payments.verifone_google_pay.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.GOOGLE_PAY][PaymentIssuer.VERIFONE],
  'integrations.payments.verifone_apple_pay.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.APPLE_PAY][PaymentIssuer.VERIFONE],
  'integrations.payments.verifone_bnpl.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.BNPL][PaymentIssuer.VERIFONE],
  'integrations.payments.sodexo.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.ECOCHEQUE][PaymentIssuer.SODEXO],
  'integrations.payments.bancontact.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.BANCONTACT],
  'integrations.payments.edenred.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.ECOCHEQUE][PaymentIssuer.EDENRED],
  'integrations.payments.monizze.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.ECOCHEQUE][PaymentIssuer.MONIZZE],
  'integrations.payments.apple_pay.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.GOOGLE_PAY][PaymentIssuer.VERIFONE],
  'integrations.payments.cash.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.CASH],
  'integrations.payments.google_pay.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.GOOGLE_PAY][PaymentIssuer.VERIFONE],
  'integrations.payments.stripe_google_pay.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.GOOGLE_PAY][PaymentIssuer.STRIPE],
  'integrations.payments.stripe_apple_pay.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.APPLE_PAY][PaymentIssuer.STRIPE],
  'integrations.payments.instant_payment.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.INSTANT_PAYMENT],
  'integrations.payments.invoice.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INVOICE_DE],
  'integrations.payments.paypal.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.PAYPAL],
  'integrations.payments.przelewy24.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.PRZELEWY],
  'integrations.payments.santander_ccp_installment.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INSTALLMENT],
  'integrations.payments.santander_factoring_de.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_FACTORING_DE],
  'integrations.payments.santander_installment_at.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INSTALLMENT_AT],
  'integrations.payments.santander_invoice_at.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INVOICE_AT],
  'integrations.payments.santander_installment_dk.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INSTALLMENT_DK],
  'integrations.payments.santander_installment_nl.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INSTALLMENT_NL],
  'integrations.payments.santander_installment_no.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INSTALLMENT_NO],
  'integrations.payments.santander_installment_se.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INSTALLMENT_SE],
  'integrations.payments.santander_installment_uk.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INSTALLMENT_UK],
  'integrations.payments.santander_installment_de.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INSTALLMENT],
  'integrations.payments.santander_installment.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INSTALLMENT],
  'integrations.payments.santander_invoice_de.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INVOICE_DE],
  'integrations.payments.santander_invoice_no.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INVOICE_NO],
  'integrations.payments.santander_pos_factoring_de.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_POS_FACTORING_DE],
  'integrations.payments.santander_pos_installment_dk.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_POS_INSTALLMENT_DK],
  'integrations.payments.santander_pos_installment_no.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_POS_INSTALLMENT_NO],
  'integrations.payments.santander_pos_installment_se.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_POS_INSTALLMENT_SE],
  'integrations.payments.santander_pos_installment_uk.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_POS_INSTALLMENT_UK],
  'integrations.payments.santander_pos_installment_de.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_POS_INSTALLMENT],
  'integrations.payments.santander_pos_installment.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_POS_INSTALLMENT],
  'integrations.payments.santander_pos_invoice_de.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_POS_INVOICE_DE],
  'integrations.payments.santander_pos_invoice_no.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_POS_INVOICE_NO],
  'integrations.payments.sofort.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SOFORT],
  'integrations.payments.stripe_direct_debit.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.DIRECT_DEBIT][PaymentIssuer.STRIPE],
  'integrations.payments.stripe_directdebit.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.DIRECT_DEBIT][PaymentIssuer.STRIPE],
  'integrations.payments.allianz.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ALLIANZ],
  'integrations.payments.allianz_trade_b2b_bnpl.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ALLIANZ],
  'integrations.payments.psa_b2b_bnpl.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.PSA_B2B_BNPL],
  'integrations.payments.swish.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SWEDBANK_SWISH],
  'integrations.payments.vipps.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SWEDBANK_VIPPS],
  'integrations.payments.mobile_pay.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SWEDBANK_MOBILE_PAY],
  'integrations.payments.swedbank_creditcard.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SWEDBANK_CREDITCARD],
  'integrations.payments.swedbank_invoice.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SWEDBANK_INVOICE],
  'integrations.payments.ivy.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.IVY],
  'integrations.payments.ideal.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.IDEAL][PaymentIssuer.STRIPE],
  'integrations.payments.stripe-ideal.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.IDEAL][PaymentIssuer.STRIPE],
  'integrations.payments.ppro-ideal.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.IDEAL][PaymentIssuer.PPRO],
  'integrations.payments.trustly.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.TRUSTLY],
  'integrations.payments.swedbank-trustly.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.TRUSTLY][PaymentIssuer.SWEDBANK],
  'integrations.payments.ppro-trustly.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.TRUSTLY][PaymentIssuer.PPRO],
  'integrations.payments.zinia_slice_three_de.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ZINIA_SLICE_THREE_DE],
  'integrations.payments.openbank_pos.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ZINIA_POS],
  'integrations.payments.zinia_slice_three.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ZINIA_SLICE_THREE],
  'integrations.payments.santander_installment_fi.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INSTALLMENT_FI],
  'integrations.payments.zinia_bnpl_de.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ZINIA_BNPL_DE],
  'integrations.payments.santander_installment_be.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INSTALLMENT_BE],
  'integrations.payments.google-pay.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.GOOGLE_PAY][PaymentIssuer.VERIFONE],
  'integrations.payments.zinia_installment_de.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ZINIA_INSTALLMENT_DE],
  'integrations.payments.zinia_installment.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ZINIA_INSTALLMENT],
  'integrations.payments.hsbc.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.HSBC],
  'integrations.payments.apple-pay.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.APPLE_PAY][PaymentIssuer.VERIFONE],
  'integrations.payments.santander_instant_at.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_INSTANT_AT],
  'integrations.payments.bfs_b2b_bnpl.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.BFS_B2B_BNPL],
  'integrations.payments.santander_pos_installment_fi.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.SANTANDER_POS_INSTALLMENT_FI],
  'integrations.payments.zinia_pos_de.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ZINIA_POS_DE],
  'integrations.payments.zinia_lending_de.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ZINIA_LENDING_DE],
  'integrations.payments.zinia_pos_lending_de.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ZINIA_POS_LENDING_DE],
  'integrations.payments.pay_by_bank.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.PAY_BY_BANK],
  'integrations.payments.verifone_creditcard.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.CREDIT_CARD][PaymentIssuer.VERIFONE],
  'integrations.payments.verifone-direct-debit.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.DIRECT_DEBIT][PaymentIssuer.VERIFONE],
  'integrations.payments.verifone_direct_debit.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.DIRECT_DEBIT][PaymentIssuer.VERIFONE],
  'integrations.payments.stripe-direct-debit.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.DIRECT_DEBIT][PaymentIssuer.STRIPE],
  'integrations.payments.zinia_pos_slice_three.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ZINIA_POS_SLICE_THREE],
  'integrations.payments.zinia_pos_slice_three_de.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ZINIA_POS_SLICE_THREE_DE],
  'integrations.payments.zinia_pos_installment.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ZINIA_POS_INSTALLMENT],
  'integrations.payments.zinia_pos_installment_de.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.ZINIA_POS_INSTALLMENT_DE],
  'integrations.payments.twint.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.TWINT],
  'integrations.payments.blik.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.BLIK],
  'integrations.payments.eps.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.EPS],
  'integrations.payments.wero.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.WERO],
  'integrations.payments.ppro-wero.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.WERO][PaymentIssuer.PPRO],
  'integrations.payments.bizum.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.BIZUM],
  'integrations.payments.stripe.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.CREDIT_CARD][PaymentIssuer.STRIPE],
  'integrations.payments.resurs_installment.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.RESURS_INSTALLMENT],
  'integrations.payments.resurs_pos_installment.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.RESURS_POS_INSTALLMENT],
  'integrations.payments.resurs_invoice.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.RESURS_INVOICE],
  'integrations.payments.resurs_pos_invoice.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.RESURS_POS_INVOICE],
  'integrations.payments.global_payments.title':
    PAYMENT_ISSUER_TRANSLATIONS[PaymentMethodEnum.CREDIT_CARD][PaymentIssuer.GLOBAL_PAYMENTS],
  'integrations.payments.payback.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.PAYBACK],
  'integrations.payments.powerpay_installment.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.POWERPAY_INSTALLMENT],
  'integrations.payments.powerpay_revolving.title':
    PAYMENT_TRANSLATIONS[PaymentMethodEnum.POWERPAY_REVOLVING],
};
